import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Drawer,
  Button,
  Typography,
  Input,
  Switch,
  Checkbox,
  Select,
} from "antd";
import { PlusCircleFilled, FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";

import useAxios from "./../../../CustomHooks/useAxios";
import ShowTable from "./ShowTable";
// import ShowTable from "./backup_ShowTable";
// import ShowTableCount from './ShowTableCount';
import PageLink from "./../../PageLink/PageLink";
import Add from "./Add";
// import Upload from "./Upload";
// import UploadAntd from "./UploadAntd";
import DebounceSelect from "./../../DebounceSelect";

const { Option } = Select;
export default function AgentStatus() {
  let { page } = useParams();
  let navigate = useNavigate();
  const { axiosi } = useAxios();

  const user = useSelector((state) => state.loginReducer.user);

  const [visibleAdd, setVisibleAdd] = useState(false);
  const [data, setData] = useState();

  // const [companyid, setCompanyid] = React.useState();
  const [companyid, setCompanyid] = React.useState({
    value: user.agents[0].company_id,
    label: user.agents[0].gmcomname,
  });
  const [tel, setTel] = useState("");
  const [name, setName] = useState("");

  const [surveyplan_id, setSurveyplan_id] = React.useState();

  const [enableAutoRefresh, setEnableAutoRefresh] = useState(true);
  const [loaddingData, setLoaddingData] = useState(false);
  const [refressSearch, setRefressSearch] = useState(true);
  const hideItem = useSelector((state) => state.loginReducer.hideItem);
  const [enableSearch, setEnableSearch] = useState(true);
  const [agentStatus, setAgentStatus] = useState(localStorage.getItem("AGENT_STATUS_STATE") || "");
  const [isFullScreen, setIsFullScreen] = useState(false);

  const toggleFullScreen = () => {
    const elem = document.getElementById("searchResultContainer");
    if (!document.fullscreenElement) {
      if (elem?.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem?.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }
  };

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullScreen(!!document.fullscreenElement || !!document.webkitFullscreenElement);
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);

  const [departmentData, setDepartmentData] = useState(null);
  const [departmentSelected, setDepartmentSelected] = useState([]);
  const [exten, setExten] = useState(() => {
    const saved = localStorage.getItem("AGENT_STATUS_EXTEN");
    return saved ? JSON.parse(saved) : [];
  });
  const [extenValue, setExtenValue] = useState(() => {
    const saved = localStorage.getItem("AGENT_STATUS_EXTEN_VAL");
    return saved ? JSON.parse(saved) : [];
  });
  const [refreshOptionExten, setRefreshOptionExten] = useState(true);
  const handleOnChangeIto = async (value) => {
    setExten(value);
    localStorage.setItem("AGENT_STATUS_EXTEN", JSON.stringify(value));
    if (value && value.length > 0) {
      const extValues = value.map((v) => displayExt(v.value));
      setExtenValue(extValues);
      localStorage.setItem("AGENT_STATUS_EXTEN_VAL", JSON.stringify(extValues));
    } else {
      setExtenValue([]);
      localStorage.setItem("AGENT_STATUS_EXTEN_VAL", JSON.stringify([]));
    }
  };
  const handleAgentOnClear = () => {
    setExten([]);
    setExtenValue([]);
    localStorage.setItem("AGENT_STATUS_EXTEN", JSON.stringify([]));
    localStorage.setItem("AGENT_STATUS_EXTEN_VAL", JSON.stringify([]));
  };
  useEffect(() => {
    const getDepartmentData = async () => {
      try {
        const kq = await axiosi.get("department", {
          params: { company_id: companyid.value, pageSize: 100 },
        });
        console.log(kq.data.rows);
        setDepartmentData(kq.data.rows);
        const savedDeps = localStorage.getItem("AGENT_STATUS_DEPS");
        setDepartmentSelected(
          savedDeps ? JSON.parse(savedDeps) : user && user?.agents[0].log_agent_status_deps
        );
      } catch (err) {
        setDepartmentData([]);
        console.log("[useEffect]:getDepartmentData has an Error !");
      }
    };
    getDepartmentData();
  }, [companyid?.value]);

  useEffect(() => {
    setRefreshOptionExten((pre) => !pre);
  }, [companyid?.value]);

  useEffect(() => {
    doSearch();

    // return()=> {
    //     console.log('[useEffect]:set setEnableSearch=false');
    //     // setEnableSearch(false);
    // }
  }, [refressSearch, page, extenValue]);
  async function fetchUserList(company_name) {
    console.log("fetching user", company_name);
    const body = await axiosi.get("companies", {
      params: { company_name, pageSize: 100 },
    });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.company_name,
        value: user.id,
      }));
    } else {
      const a = [{ label: "---no data---", value: "" }];
      return a.map((i) => i);
    }
    // return axiosi.get('companies',{params:{company_name,pageSize:100}} ) // fetch('https://randomuser.me/api/?results=5')
    //   .then((body) =>
    //     body?.data?.rows.map((user) => ({
    //      label: user.company_name,
    //       value: user.id,
    //     })),
    //   );
  }
  async function fetchSurveyPlan(surveyplan_name) {
    console.log("fetchSurveyPlan", surveyplan_name);
    const body = await axiosi.get("surveyplan", {
      params: { company_id: companyid, name: surveyplan_name, pageSize: 100 },
    });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.name,
        value: user.id,
      }));
    } else {
      const a = [{ label: "---no data---", value: "" }];
      return a.map((i) => i);
    }
    // return axiosi.get('companies',{params:{company_name,pageSize:100}} ) // fetch('https://randomuser.me/api/?results=5')
    //   .then((body) =>
    //     body?.data?.rows.map((user) => ({
    //      label: user.company_name,
    //       value: user.id,
    //     })),
    //   );
  }
  const handleAdd = () => {
    console.log("[handleAdd]:");
    setVisibleAdd(true);
  };
  const onCloseAdd = () => {
    setVisibleAdd(false);
  };
  const handleSearch = async () => {
    console.log("[handleSearch]");
    setRefressSearch((pre) => !pre);
  };
  const doSearch = async () => {
    // console.log("[doSearch]");
    // navigate('/ivrplanmain');
    if (!enableSearch) return;
    try {
      setLoaddingData(true);
      const kq = await axiosi.get("queues/agentStatusb", {
        params: {
          page,
          tel,
          name,
          surveyplan_id: surveyplan_id?.value,
          company_id: companyid?.value,
          department_id: departmentSelected,
          agentStatus,
        },
      });
      // console.log("[handleSearch]:kq=",kq);
      if (!enableSearch) return;
      setLoaddingData(false);
      setData(kq.data);
      if (enableAutoRefresh) {
        if (!enableSearch) return;
        setTimeout(() => {
          setRefressSearch((pre) => !pre);
        }, 3000);
      }
    } catch (err) {
      console.log("ERROR");
      setLoaddingData(false);
    }
  };
  const handleOnChangeCompany = (newValue) => {
    setCompanyid(newValue);
    // Clear filters when company changes
    setExten([]);
    setExtenValue([]);
    setDepartmentSelected([]);
    localStorage.removeItem("AGENT_STATUS_EXTEN");
    localStorage.removeItem("AGENT_STATUS_EXTEN_VAL");
    localStorage.removeItem("AGENT_STATUS_DEPS");
  };
  async function onChangeEnableRefresh(checked) {
    console.log(`switch to :`, checked.target.checked);
    setEnableAutoRefresh(checked.target.checked);
    if (!loaddingData && checked.target.checked) {
      setTimeout(() => {
        setRefressSearch((pre) => !pre);
      }, 3000);
    }
  }
  const handleOnChangeDepartment = (value) => {
    console.log("[handleOnChangeDepartment]:value=", value);
    setDepartmentSelected(value);
    localStorage.setItem("AGENT_STATUS_DEPS", JSON.stringify(value));
    setExten([]);
    localStorage.setItem("AGENT_STATUS_EXTEN", JSON.stringify([]));
    setExtenValue([]);
    localStorage.setItem("AGENT_STATUS_EXTEN_VAL", JSON.stringify([]));
  };
  const handleOnChangeAgentStatus = (value) => {
    console.log("[handleOnChangeAgentStatus]:value=", value);
    setAgentStatus(value);
    localStorage.setItem("AGENT_STATUS_STATE", value);
  };

  async function fetchExtenList(exten) {
    console.log("[fetchExtenList]:exten=", exten);
    const body = await axiosi.get("agents/searchExten", {
      params: {
        company_id: companyid?.value,
        department_id: departmentSelected,
        exten,
        pageSize: 200,
      },
    });
    if (body?.data?.rows) {
      return body?.data?.rows.map((user) => ({
        label: user.name,
        value: user.endpoint_id,
      }));
    } else {
      const a = [{ label: "---no data---", value: "" }];
      return a.map((i) => i);
    }
  }
  const displayExt = (endpointid) => {
    // console.log("[displayExt]:endpointid=",endpointid);
    if (endpointid) {
      const ext = endpointid.split("_");
      return ext[0];
    } else {
      return "";
    }
  };
  function checkLogDep(item) {
    if (user.agents[0].company_id === 1) return true;
    // const logdeps = user.agents[0].logdepartments;
    const logdeps = user.agents[0].log_agent_status_deps;


    return logdeps.includes(item.id);
  }
  return (
    <>
      {/* <Upload/>
  <UploadAntd/> */}
      <Drawer
        title="Add  Menu Item"
        placement="right"
        onClose={onCloseAdd}
        visible={visibleAdd}
      >
        <Add
          setRefressSearch={setRefressSearch}
          setVisibleAdd={setVisibleAdd}
        />
        {/* <Switch  size="small" checkedChildren="Running" unCheckedChildren="Stopped" checked={enableAutoRefresh} onChange={onChangeEnableRefresh} />        */}
      </Drawer>
      <section className="search">
        <div className="container">
          <div className="row">
            <Typography.Title level={3}>
              Search :
              <Checkbox
                className="addButton1"
                checked={enableAutoRefresh}
                onChange={onChangeEnableRefresh}
              >
                Auto Refresh
              </Checkbox>
              {/* <Switch   className="addButton1" checkedChildren="Auto Refresh" unCheckedChildren="Un-Refresh" checked={enableAutoRefresh} onChange={onChangeEnableRefresh} />        */}
              {/* <Button onClick={handleAdd}  className="addButton" icon={<PlusCircleFilled  style={{ color: '#1890ff' }} />}>Add</Button> */}
            </Typography.Title>
          </div>

          <div className="row gap1">
            <div className={hideItem}>
              <label>Company :</label>
              <DebounceSelect
                showSearch={true}
                value={companyid}
                placeholder="Select a company !"
                fetchOptions={fetchUserList}
                onChange={handleOnChangeCompany}
                style={{ width: "100%" }}
              />
            </div>

            {/* <div className="col">
                    <label>Survey Plan :</label>
                    <DebounceSelect
                        showSearch={true}
                        value={surveyplan_id}
                        placeholder="Select a survey plan !"
                        fetchOptions={fetchSurveyPlan}
                        onChange={(newValue) => {setSurveyplan_id(newValue);  }}
                        style={{  width: '100%',   }}
                    />
                </div>
                <div className="col">
                    <label>Name :</label>
                    <Input  onChange={({ target: { value } } )=>setName(value)}/>
                </div>
                <div className="col">
                    <label>Tel :</label>
                    <Input  onChange={({ target: { value } } )=>setTel(value)}/>
                </div> */}

            <div>
              <label>Department:</label>

              <Select
                mode="multiple"
                allowClear
                style={{ width: "100%" }}
                onChange={handleOnChangeDepartment}
                value={departmentSelected}
              >
                <Option value=""></Option>
                {departmentData &&
                  departmentData.map((item) => {
                    if (checkLogDep(item)) {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      );
                    }
                  })}
              </Select>
              {/* <Select style={{ width: '100%' }} className={"minWidth2"}
                            onChange={handleOnChangeDepartment}                            
                            value={departmentSelected}                    
                    >
                        <Option value=""></Option>
                        { departmentData &&  departmentData.map(item=>(
                           <Option key={item.id} value={item.id}>{item.name}</Option>
                       ))}                       
                    </Select> */}
            </div>
            <div className1={hideItem}>
              <label>Agent :</label>
              <DebounceSelect
                className={"minWidth2"}
                selectMode={"multiple"}
                refreshOption={refreshOptionExten}
                showSearch={true}
                value={exten}
                placeholder=""
                fetchOptions={fetchExtenList}
                onChange={handleOnChangeIto}
                onClear={handleAgentOnClear}
                style={{ width: "100%" }}
              />
            </div>
            <div>
              <label>Status:</label>

              <Select
                style={{ width: "100%" }}
                className={"minWidth2"}
                onChange={handleOnChangeAgentStatus}
                value={agentStatus}
              >
                <Option value=""></Option>
                <Option value="5">Unavailiable</Option>
                <Option value="Online">Online</Option>
                <Option value="Incall">InUsed</Option>
                <Option value="Idle">Idle</Option>
                <Option value="IdlePaused">Idle | Paused</Option>
                <Option value="Paused">Paused</Option>
              </Select>
            </div>

            <div className="col">
              <label>Search:</label>
              <Button onClick={handleSearch}>Search :</Button>
            </div>
          </div>
        </div>
      </section>
      <section className={`searchResult ${isFullScreen ? "fullscreen-active" : ""}`} id="searchResultContainer">
        <div className="search-result-header">
          <Typography.Title level={3} style={{ margin: 0 }}>Result</Typography.Title>
          <Button
            className="btn-fullscreen-toggle"
            icon={isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
            onClick={toggleFullScreen}
          >
            {isFullScreen ? "Thoát toàn màn hình" : "Toàn màn hình"}
          </Button>
        </div>
        {/* <div className="row">
            {data?.rows && <ShowTableCount departmentSelected={departmentSelected} agentStatus={agentStatus} data={data?.rows.countAll} setRefressSearch={setRefressSearch} />}
        </div> */}
        <div className="row">
          {data?.rows && (
            <ShowTable
              departmentSelected={departmentSelected}
              exten={extenValue}
              agentStatus={agentStatus}
              data={data?.rows}
              setRefressSearch={setRefressSearch}
            />
          )}
        </div>
        {/* <div className="row">
        {data?.pages>1?<PageLink pageSize={data.pageSize} searchpage={"blacklist"} pages={data.pages} numrows={data.numrows} page={data.page} />:<h1>chi co' 1 page</h1>}
        </div> */}
      </section>
    </>
  );
}
